import axios from "axios"
import ApiConfig from "../config/ApiConfig";

export const getAppointmentNote = async() =>{
    const response = await axios.get()
    if (response?.data?.status === 200) {
        return response.data?.data || '';
      }
}

export const addAppointmentNote = async (params) => {
    const response = await axios.post(`${ApiConfig.appointmentNote}`, params);
    if (response?.data?.status === 200) {
      return response.data || '';
    }
  }

  export const deleteAppointmentNote = async (id) => {
    const response = await axios.delete(`${ApiConfig.blogList}/deleteblog?blogId=${id}`);
    if (response?.data?.status === 200) {
      return response.data?.data || '';
    }
  }

  export const encounterAppointmentNote = async (parms) =>{
    const response = await axios.post(`${ApiConfig.encounterAppointmentNote}`, parms);
    if (response?.data?.status === 200) {
      return response.data?.data || '';
    }
  }


  export const updateParticipantsStatus = async (status, appointmentId, userId) =>{
    const response = await axios.post(`${ApiConfig.updateParticipantsStatus}?newStatus=${status}&bookingId=${appointmentId}&userId=${userId}`);
    if (response?.data?.status === 200) {
      return response.data || '';
    }
  }